import { type FC } from "react";
import { FormItemName } from "@root/shared/components/FormItemName";
import { InformationText } from "@root/shared/components/InformationText";
import { SelectBox } from "@root/shared/components/SelectBox";
import { RadioWithLabel } from "@userFrontend/features/promotion/components/RadioWithLabel";
import { DateSelector } from "@userFrontend/components/DateSelector";
import { StepCassette } from "../StepCassette";
import * as styles from "./styles.css";
import { headingEmphasis } from "../../styles.css";

type Props = {
  yearOptions: { label: string; value: number }[];
  prefectureOptions: { label: string; value: string }[];
  cityOptions: { label: string; value: string }[];
  sexValue?: string;
  prefectureValue?: string;
  cityValue?: string;
  yearValue?: number;
  monthValue?: number;
  dateValue?: number;
  onChangeSex: (value: string) => void;
  onChangePrefecture: (value: string) => void;
  onChangeCity: (value: string) => void;
  onChangeYear: (value: number) => void;
  onChangeMonth: (value: number) => void;
  onChangeDate: (value: number) => void;
  sexErrorMessage?: string;
  addressErrorMessage?: string;
  birthDateErrorMessage?: string;
  isLoadingPrefectures: boolean;
  isLoadingCities: boolean;
};

export const Presentation: FC<Props> = ({
  yearOptions,
  prefectureOptions,
  cityOptions,
  sexValue,
  prefectureValue,
  cityValue,
  yearValue,
  monthValue,
  dateValue,
  onChangeSex,
  onChangePrefecture,
  onChangeCity,
  onChangeYear,
  onChangeMonth,
  onChangeDate,
  sexErrorMessage,
  addressErrorMessage,
  birthDateErrorMessage,
  isLoadingPrefectures,
  isLoadingCities,
}) => {
  return (
    <StepCassette
      heading={
        <>
          あなたの
          <span className={headingEmphasis}>プロフィール</span>
        </>
      }
    >
      <div className={styles.fieldWrapper}>
        <FormItemName labelRequirementType="required">性別</FormItemName>
        <span className={styles.radioButtonWrapper}>
          <RadioWithLabel
            id="gender_male"
            name="gender"
            label="男性"
            value="male"
            checked={sexValue === "male"}
            onChange={(e) => onChangeSex(e.target.value)}
            hasError={!!sexErrorMessage}
          />
          <RadioWithLabel
            id="gender_female"
            name="gender"
            label="女性"
            value="female"
            checked={sexValue === "female"}
            onChange={(e) => onChangeSex(e.target.value)}
            hasError={!!sexErrorMessage}
          />
        </span>
        {sexErrorMessage && (
          <InformationText isAlert text={sexErrorMessage} className={styles.errorMessage} />
        )}
      </div>
      <div className={styles.fieldWrapper}>
        <FormItemName labelRequirementType="required">生年月日</FormItemName>
        <div className={styles.selectBoxWrapper}>
          <DateSelector
            year={{
              options: yearOptions,
              value: yearValue,
              onChange: onChangeYear,
              hasError: !!birthDateErrorMessage,
            }}
            month={{
              value: monthValue,
              onChange: onChangeMonth,
              hasError: !!birthDateErrorMessage,
            }}
            date={{
              value: dateValue,
              onChange: onChangeDate,
              hasError: !!birthDateErrorMessage,
            }}
          />
        </div>
        {birthDateErrorMessage && (
          <InformationText isAlert text={birthDateErrorMessage} className={styles.errorMessage} />
        )}
      </div>
      <div className={styles.fieldWrapper}>
        <FormItemName labelRequirementType="required">住所</FormItemName>
        <div className={styles.selectBoxWrapper}>
          <SelectBox
            options={prefectureOptions}
            value={prefectureValue}
            selected={!!prefectureValue}
            placeholder="都道府県"
            onChange={(e) => onChangePrefecture(e.target.value)}
            hasError={!!addressErrorMessage}
            disabled={isLoadingPrefectures}
          />
          <SelectBox
            options={cityOptions}
            value={cityValue}
            selected={!!cityValue}
            placeholder="市区町村"
            onChange={(e) => onChangeCity(e.target.value)}
            hasError={!!addressErrorMessage}
            disabled={isLoadingCities}
          />
        </div>
        {addressErrorMessage && (
          <InformationText isAlert text={addressErrorMessage} className={styles.errorMessage} />
        )}
      </div>
    </StepCassette>
  );
};
